export default "__VITE_ASSET__89e8hObf__"